//匹配路由,确定底部导航active

import router from '@router';

export function activeTabBar() {
	let activeIndex = 0;
	/*if (router.matchRoutes([
			/^\/shop/       //商城
		])) {
		activeIndex = 1;
	} else if (router.matchRoutes([
			/^\/article\//,   //资讯，公开课
			/^\/$/,            //首页
			/^\/zhuanqu\//,    //专区
		])) {
		activeIndex = 0;
	}*/
	if (router.matchRoutes([
		/^\/home\/index/      //(取消)一点百通首页（现只有一点百通首页高亮）
	])) {
		// activeIndex = 0;
		activeIndex = "";
	} else {
		activeIndex = null;
	}
	return activeIndex;
}
